import React, { useEffect } from 'react';
// import SelectInput from '../../../../components/SelectInput';
// import LabelTooltip from '../../../../components/LabelTooltip';
// import { InformationCircleIcon } from '@heroicons/react/24/solid';
// import { Input } from '../../../../components/ui/input';
// import SelectDate from '../../../../components/SelectDate';
import FormField from '../../../../components/FormField';
import FormSection from './FormSection';
// import { DatePicker } from '../../../../components/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { setUploadData, setErrors, getProjectsForMaster } from '../../../../store/uploads/actions';
import constants from '../../../../commonUtils/constants';
// import { setFilters, getProjects } from '../../../../store/projects/actions';

const FormFieldsSection = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.Auth);
    const { pageLoadData, uploadData, errors } = useSelector((state) => state.Uploads);

    const handleInputChange = (key, value) => {
        const newUploadData = { ...uploadData };
        
        // Handle master project logic
        if (key === "masterProject") {
            const masterProjectId = value || "";
            if (masterProjectId !== "") {
                dispatch(getProjectsForMaster(masterProjectId));
            }
        }

        // Handle source type logic
        if (key === "sourceType" && value === "Channel Partner") {
            newUploadData.channelPartner = "";
            newUploadData.procReason = "Channel Partner";
        } else if (key === "sourceType") {
            newUploadData.procReason = "";
        }

        // Handle duplicate validation for vendor/channelPartner
        if ((key === 'vendor' || key === 'channelPartner') && value) {
            const list = key === 'vendor' ? pageLoadData?.vendors : pageLoadData?.channelPartners;
            const exists = list?.some(item => 
                item.label?.toLowerCase() === value.toLowerCase()
            );
            
            const newErrors = { ...errors };
            
            if (exists) {
                newErrors[key] = `${key === 'vendor' ? 'Vendor' : 'Channel Partner'} already exists`;
            } else {
                delete newErrors[key];
            }
            
            dispatch(setErrors(newErrors));
        } else {
            // Clear all errors for other fields
            dispatch(setErrors(constants.upload.errorInitialState));
        }
        
        dispatch(setUploadData({ ...newUploadData, [key]: value }));
    };

    useEffect(() => {
        if (!uploadData.uploadedBy && user?._id) {
            dispatch(setUploadData({ ...uploadData, uploadedBy: user?._id }));
        }
    }, [dispatch, uploadData, uploadData.uploadedBy, user?._id]);
    

    return (
        <div className="grid grid-cols-1 gap-4">
            {pageLoadData.sourceTypes?.length > 0 &&
                <FormSection title="Source Type">
                    <FormField
                        fieldKey="sourceType"
                        label="Source Type"
                        type="list"
                        required={true}
                        data={pageLoadData?.sourceTypes}
                        value={uploadData?.sourceType}
                        error={errors?.sourceType}
                        handleChange={handleInputChange}
                        tooltipText={constants.upload.tooltipTexts?.sourceType}
                    />
                </FormSection>
            }
            <FormSection title="Project Information">
                <FormField
                    fieldKey="masterProject"
                    label="Master Project"
                    type="map"
                    required={true}
                    data={pageLoadData?.masterProjects}
                    value={uploadData?.masterProject}
                    error={errors?.masterProject}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.masterProject}
                />
                <FormField
                    fieldKey="project"
                    label="Project"
                    type="map"
                    required={true}
                    data={pageLoadData?.projects}
                    value={uploadData?.project}
                    error={errors?.project}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.project}
                />
            </FormSection>
            <FormSection title="Associated Personnel">
                <FormField
                    fieldKey="vendor"
                    label="Vendor"
                    type="map"
                    required={true}
                    data={pageLoadData?.vendors}
                    value={uploadData?.vendor}
                    error={errors?.vendor}
                    handleChange={handleInputChange}
                    className={uploadData?.sourceType !== "Channel Partner" ? 'block' : 'hidden'}
                    tooltipText={constants.upload.tooltipTexts?.vendor}
                />
                <FormField
                    fieldKey="channelPartner"
                    label="Channel Partner"
                    type="map"
                    required={true}
                    data={pageLoadData?.channelPartners}
                    value={uploadData?.channelPartner}
                    error={errors?.channelPartner}
                    handleChange={handleInputChange}
                    className={uploadData?.sourceType === "Channel Partner" ? 'block' : 'hidden'}
                    tooltipText={constants.upload.tooltipTexts?.channelPartner}
                />
                <FormField
                    fieldKey="spoc"
                    label="SPOC (Single Point of Contact)"
                    type="map"
                    required={true}
                    data={pageLoadData?.users}
                    value={uploadData?.spoc}
                    error={errors?.spoc}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.spoc}
                />
                <FormField
                    fieldKey="uploadedBy"
                    label="Uploaded By"
                    type="map"
                    required={true}
                    disabled={true}
                    data={pageLoadData?.uploadedBy}
                    value={uploadData?.uploadedBy || user?._id}
                    error={errors?.uploadedBy}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.uploadedBy}
                />
            </FormSection>
            <FormSection title="Additional Information">
                <FormField
                    fieldKey="dataCategory"
                    label="Data Category"
                    type="map"
                    required={true}
                    data={pageLoadData?.dataCategories}
                    value={uploadData?.dataCategory}
                    error={errors?.dataCategory}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.dataCategory}
                />
                <FormField
                    fieldKey="leadSource"
                    label="Lead Source"
                    type="map"
                    required={true}
                    data={pageLoadData?.leadSources}
                    value={uploadData?.leadSource}
                    error={errors?.leadSource}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.leadSource}
                />
                <FormField
                    fieldKey="extractedOn"
                    label="Extracted On"
                    type="date"
                    required={false}
                    data={[]}
                    value={uploadData?.extractedOn}
                    error={errors?.extractedOn}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.extractedOn}
                />
                <FormField
                    fieldKey="procReason"
                    label="Reason of Procurement"
                    type="input"
                    required={false}
                    value={uploadData?.procReason}
                    error={errors?.procReason}
                    handleChange={handleInputChange}
                    tooltipText={constants.upload.tooltipTexts?.procReason}
                />
                {/* <DatePicker/> */}
            </FormSection>
        </div>
    )
};

export default FormFieldsSection;
